import React, { HTMLAttributes, FC } from "react";
import { Skeleton } from "../../../core/Skeleton";
import { useStyles } from "./ProfileInfoLoading.style";
import { useParams } from "react-router-dom";

export const ProfileInfoLoading: FC<HTMLAttributes<HTMLDivElement>> = () => {
  const classes = useStyles();
  const { userId: userIdParam }: { userId?: string } = useParams();

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <Skeleton variant="circle" width={80} height={80} />
        <Skeleton variant="text" width={200} height={40} />
      </div>
      <div className={classes.buttons}>
        <Skeleton variant="rect" width={"50%"} height={33} borderRadius={5} />
        <Skeleton variant="rect" width={"50%"} height={33} borderRadius={5} />
      </div>
      <span className={classes.line} />
      {!userIdParam && (
        <div className={classes.buttons}>
          <Skeleton variant="rect" width={"20%"} height={33} borderRadius={5} />
          <Skeleton variant="rect" width={"30%"} height={33} borderRadius={5} />
          <Skeleton variant="rect" width={"40%"} height={33} borderRadius={5} />
        </div>
      )}
    </div>
  );
};
